import Vue from 'vue'
import Router from 'vue-router'

import monitor from '@/pages/index/router/modules/monitor'
import personal from '@/pages/index/router/modules/personal'
import privilege from '@/pages/index/router/modules/privilege'
import settings from '@/pages/index/router/modules/settings'
import message from '@/pages/index/router/modules/message'
import enterpriseAdmin from '@/pages/index/router/modules/enterpriseAdmin'
import tenantManager from '@/pages/index/router/modules/tenantManager'
import developer from '@/pages/index/router/modules/developer'
import center from '@/pages/index/router/modules/personCenter'
import dstConfig from '@/pages/index/router/modules/dstConfig'
import licenseRouter from '@/pages/index/router/modules/license'
import statistics from '@/pages/index/router/modules/statistics'
import accManager from '@/pages/index/router/modules/accManager'
import hybird from '@/pages/index/router/modules/hybird'
// const Layout = r =>
//   require.ensure([], () => r(require('@/layout/layout2.vue')), 'base')

const LoginPage = r =>
  require.ensure([], () => r(require('@/layout/login.vue')), 'base')

const docPage = r =>
  require.ensure([], () => r(require('@/components/docPage.vue')), 'base')

const chartPage = r =>
  require.ensure(
    [],
    () => r(require('@/modules/tenantManager/dashboard/dashboard.vue')),
    'tenant'
  )

const smartdbsVersion = r =>
  require.ensure(
    [],
    () => r(require('@/components/smartdbsVersion.vue')),
    'base'
  )

const smartdbsPrivacy = r =>
  require.ensure(
    [],
    () => r(require('@/components/smartdbsPrivacy.vue')),
    'base'
  )

const loginAuto1 = r =>
  require.ensure(
    [],
    () => r(require('@/components/loginAuto1.vue')),
    'loginAuto'
  )

const loginAutoLayout = r =>
  require.ensure(
    [],
    () => r(require('@/components/loginAutoLayout.vue')),
    'loginAuto'
  )

const findPassword = r =>
  require.ensure([], () => r(require('@/components/findPassword.vue')), 'base')
// const RegisterPage = r => require.ensure([], () => r(require('@/components/RegisterPage.vue')), 'base')
const RegisterPage = r =>
  require.ensure([], () => r(require('@/components/register.vue')), 'base')

const Page404 = r =>
  require.ensure([], () => r(require('@/components/404.vue')), 'base')
const dashboard = r => {
  require.ensure(
    [],
    () => r(require('@/modules/dashboard/index.vue')),
    'dashboard'
  )
}

Vue.use(Router)

// 静态路由配置
export const constantRouter = [
  {
    path: '/version',
    name: 'version',
    component: smartdbsVersion,
    hidden: true,
    meta: {
      auth: false
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: smartdbsPrivacy,
    hidden: true,
    meta: {
      auth: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    hidden: true,
    meta: {
      auth: false,
      permission: ['login']
    }
  },
  {
    path: '/chartPage',
    name: 'chartPage',
    component: chartPage,
    hidden: true,
    meta: {
      auth: false
    }
  },
  {
    path: '/docPage',
    name: 'docPage',
    component: docPage,
    hidden: true,
    meta: {
      auth: false
    }
  },
  {
    path: '/loginAuto',
    name: 'loginAuto',
    component: loginAutoLayout,
    meta: {
      auth: false
    },
    hidden: true,
    redirect: '/loginAuto/v1.0',
    children: [
      {
        path: '/loginAuto/v1.0',
        name: 'v1.0',
        component: loginAuto1,
        meta: {
          id: '',
          auth: false
        }
      }
    ]
  },
  {
    path: '/findPassword',
    name: 'findPassword',
    component: findPassword,
    hidden: true,
    meta: {
      auth: false,
      permission: ['findPassword']
    }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterPage,
    hidden: true,
    meta: {
      auth: false,
      permission: ['register']
    }
  },
  {
    path: '/404',
    name: 'pagenotfound',
    hidden: true,
    component: Page404,
    meta: {
      auth: false
    }
  },
  {
    path: '/index',
    name: 'index',
    hidden: true,
    redirect: '/login',
    meta: {
      auth: false,
      permission: ['login']
    }
  },
  {
    path: '/',
    name: 'baseLogin',
    hidden: true,
    redirect: '/login',
    meta: {
      auth: false,
      permission: ['login']
    }
  },
  ...center
]

export default new Router({
  // mode: 'history',
  routes: constantRouter
})

// 动态路由
export const asyncRouterMap = [
  monitor,
  personal,
  privilege,
  settings,
  message,
  dstConfig,
  licenseRouter,
  statistics,
  ...hybird,
  ...enterpriseAdmin,
  ...tenantManager,
  ...developer,
  ...accManager,
  // ...center,
  {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboard,
    meta: {
      id: '7f434c1e1c4a428b8c4a5a2f0eca33ed',
      auth: false
    }
  },
  {
    path: '*',
    redirect: '/404',
    name: 'Page404',
    meta: {
      auth: false,
      id: ''
    },
    hidden: true
  }
]

export const getRouterMap = () => {
  let temp = []
  asyncRouterMap.forEach(element => {
    temp.push(Object.assign({}, element))
  })
  return temp
}



// WEBPACK FOOTER //
// ./src/pages/index/router/index.js